// import { History, createBrowserHistory } from "history";
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import MainPageComponent from "./main/main.component";

import ErrorPage from "~/view/error/error-page/error-page.component";

// const BROWSER_HISTORY: History = createBrowserHistory();

export const RoutesComponent: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPageComponent />} />
        <Route path="*" element={<ErrorPage message="Ничего не найдено по данному адресу" />} />
      </Routes>
    </Router>
  );
};
